import { createApp } from 'vue'

import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import App from '@/App.vue'
import { registerPlugins } from '@core/utils/plugins'
import { initAuth } from '@/utils/firebaseAuth'

// Styles
import '@core/scss/template/index.scss'
import '@styles/styles.scss'

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
}

const firebaseApp = initializeApp(firebaseConfig)
const auth = getAuth(firebaseApp)

// Attach the onIdTokenChanged listener before the router runs guards. The
// guard awaits authReady from firebaseAuth so we never read stale cookies on
// cold load.
initAuth()

// Create vue app
const app = createApp(App)

// Provide firebase auth instance to all components
app.provide('auth', auth)

// Import the functions you need from the SDKs you need
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Register plugins
registerPlugins(app)

// Mount vue app
app.mount('#app')
